var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isPermitted)?_c('button',_vm._g(_vm._b({class:['btn', _vm.context],attrs:{"disabled":_vm.disabled,"type":_vm.$attrs.type ? _vm.$attrs.type : 'button'}},'button',_vm.$attrs,false),_vm.$listeners),[_c('div',{class:['relative flex items-center justify-center', _vm.size]},[_c('span',{class:[
        'space-x-2 items-center justify-center w-full truncate',
        _vm.font,
        _vm.$attrs.loading ? 'hidden' : 'flex',
      ]},[_vm._t("default"),_c('span',[_vm._v(_vm._s(_vm.text))])],2),_vm._t("after"),(_vm.$attrs.loading)?_c('base-icon',{class:['animate-spin'],staticStyle:{"font-size":"150%"},attrs:{"icon":"spinner-btn"}}):_vm._e()],2)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }